import { render, staticRenderFns } from "./Completed.vue?vue&type=template&id=f675e03c&"
import script from "./Completed.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Completed.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports